import { render, staticRenderFns } from "./PqrCliente.vue?vue&type=template&id=b4308142&scoped=true"
import script from "./PqrCliente.vue?vue&type=script&lang=js"
export * from "./PqrCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4308142",
  null
  
)

export default component.exports